import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsTransferModalOpen = createStore(() => useState(false));
